define.alias("shared/components/shared/ui/profile-color-option", "media/components/shared/ui/profile-color-option");